import { observer, inject } from "mobx-react";

import React, { Component } from "react";
import "../Passport.css";

import FinishSocialSignup from "./FinishSocialSignup";
import queryString from "query-string";

class FinishSocialSignupContainer extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.followRedirects = this.followRedirects.bind(this);
    }

    followRedirects = () => !(this.queryValues().redirect == 'false')

    googleToken = () => this.props.rootStore.profileStore.googleToken

    queryValues = () => queryString.parse(this.props.location.search);
    
    tokenIsSet() {
        return (
            this.googleToken() !== undefined &&
            this.googleToken().length > 0
        );
    }

    handleSubmit = (username: string) => {
        var component = this;
        this.props.rootStore.profileStore.finishGoogleSignup(username, function(
            error: boolean
        ) {
            console.log("Doing ")
            if (!error) {
                if (component.followRedirects() !== false) {
                    console.log("Redirecting because user is logged in");
                    component.props.history.push("/");
                }
            }
        });
    };

    render() {
        return (
            <FinishSocialSignup
                usernameError={this.props.rootStore.uiStore.fieldError.username}
                tokenIsSet={this.tokenIsSet()}
                handleSubmit={this.handleSubmit}
                status={this.props.rootStore.profileStore.status}
                statusMessage={this.props.rootStore.profileStore.statusMessage}
                followRedirects={this.followRedirects()}
            />
        );
    }
}

export default observer(FinishSocialSignupContainer);
